import React, { useState, useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { Textarea, Icon, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import HtmlPreviewModal from 'components/HtmlPreviewModal';

import styles from './styles';

const useStyles = createUseStyles(styles, 'HtmlTextarea');

function HtmlTextarea({ placeholder, value, onChange, ...props }) {
    const { t } = useWeb5Context();
    const classes = useStyles();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = useCallback(() => {
        setIsModalOpen(true);
    }, []);

    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false);
    }, []);

    const handleChange = useCallback(
        (newValue) => {
            onChange?.(newValue);
        },
        [onChange],
    );

    return (
        <div className={classes.root}>
            <Textarea
                labelMode="horizontal"
                placeholder={placeholder || t('cfm_placeholder_type_value')}
                value={value}
                onChange={handleChange}
                {...props}
            />
            <div className={classes.iconContainer}>
                <Icon name="visibilityOn" onClick={handleOpenModal} />
            </div>
            <HtmlPreviewModal isOpen={isModalOpen} onClose={handleCloseModal} htmlContent={value} />
        </div>
    );
}

HtmlTextarea.propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
};

export default memo(HtmlTextarea);
